import { useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";
import { OrderState } from "@/api/vendure/order/order.types";
import { orderDetailQueryOptions } from "@/api/vendure/order/order.query.options";
import { useOrderRealtime } from "@/hooks/useOrderRealtime";
import { currentUserAtom } from "@/stores/auth.store";
import { lastOrderCodeAtom, lastOrderSlugAtom } from "@/stores/cart.store";
import { useQuery } from "@tanstack/react-query";

const TERMINAL_STATES = new Set([
  OrderState.Delivered,
  OrderState.Cancelled,
  OrderState.Rejected,
]);

export function GlobalOrderListener() {
  const lastOrderCode = useAtomValue(lastOrderCodeAtom);
  const currentUser = useAtomValue(currentUserAtom);
  const clearLastOrder = useSetAtom(lastOrderCodeAtom);
  const clearLastSlug = useSetAtom(lastOrderSlugAtom);

  useOrderRealtime(lastOrderCode ?? "", currentUser?.id);

  const { data: detail } = useQuery(
    orderDetailQueryOptions(lastOrderCode ?? "", !!lastOrderCode),
  );

  useEffect(() => {
    if (!detail) return;
    if (TERMINAL_STATES.has(detail.state as OrderState)) {
      const timer = setTimeout(() => {
        clearLastOrder(null);
        clearLastSlug(null);
      }, 30_000);
      return () => clearTimeout(timer);
    }
  }, [detail?.state, clearLastOrder, clearLastSlug]);

  return null;
}
